import { useMemo } from 'react';
import { useGetBillRequestsForAmaxPayBatchPayment } from 'shared/data/webApp/v1';

import { mapAmaxPayXeroBillInvoiceRequests } from '../../XeroAmaxPayBatchPaymentForm.helpers';
import { UseBillsForBatchPaymentData } from './XeroAmaxPayBatchPaymentFormContent.types';

export const useBillsForBatchPaymentData = ({
    companyId,
    requestId,
    filterTransfer,
    companyCurrency,
    enabled,
}: UseBillsForBatchPaymentData) => {
    const { data, isLoading } = useGetBillRequestsForAmaxPayBatchPayment(
        {
            query: { companyId, ...filterTransfer },
            path: { companyId, requestId },
        },
        { enabled }
    );

    const mappedData = useMemo(
        () => mapAmaxPayXeroBillInvoiceRequests(data?.items || [], companyCurrency),
        [companyCurrency, data?.items]
    );

    return {
        billsForBatchPaymentData: mappedData,
        billsForBatchPaymentLoading: isLoading,
    };
};
